
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: { Icon, Dropdown }
})
export default class Accordion extends Vue {
  @Prop({ default: false })
  expanded!: boolean;

  @Prop({ default: false })
  hideTitlebar!: boolean;

  @Prop({ default: false })
  disableToggle!: boolean;

  toggleContent() {
    if (this.contextMenu) {
      return;
    }

    this.$emit("toggle");
  }

  get classList() {
    return {
      "properties-panel-accordion": true,
      expanded: !this.disableToggle && (this.expanded || this.hideTitlebar)
    };
  }

  get hasContextMenuSlot() {
    return !!this.$slots.contextmenu;
  }

  contextMenu = false;
  contextMenuX = 0;
  contextMenuY = 0;

  openContextMenu(e: MouseEvent) {
    if (!this.hasContextMenuSlot) {
      return;
    }

    e.preventDefault();

    this.contextMenu = false;
    this.contextMenuX = e.clientX;
    this.contextMenuY = e.clientY;

    this.$nextTick(() => {
      this.contextMenu = true;
    });
  }
}
